export default "__VITE_ASSET__D_cHw5AU__"